import { useEffect } from "react";
import { Scatter } from "react-chartjs-2"

export const Competition = ({ data, chartRef, color = "black", }) => {
    useEffect(() => {
    }, [data])

    const options = {
        responsive: true,
        clip: false,
        animations: {
            enabled: false,
        },
        plugins: {
            datalabels: {
                anchor: "center",
                align: "right",
                offset: 15,
                color: color,
                font: {
                    weight: 100,
                    family: "SG-Regular",
                },
                borderColor: "white",
                borderTopColor: "red",
                borderWidth: 1,
                borderWidthTop: 0,
                formatter: function (value, context) {
                    return context.chart.data.labels[context.dataIndex];
                },
            },
        },
        scales: {
            x: {
                type: "linear",
                position: "center",
                min: -5,
                max: 5,
                border: {
                    color: "#707070",
                },
                grid: {
                    tickColor: "#707070",
                },
                ticks: {
                    display: false,
                },
            },
            y: {
                type: "linear",
                position: "center",
                min: -5,
                max: 5,
                border: {
                    color: "#707070",
                  },
                  grid: {
                    tickColor: "#707070",
                  },
                ticks: {
                    display: false,
                },
            },
        },
        elements: {
            point: {
                radius: 10,
                hitRadius: 10,
                hoverRadius: 10,
                backgroundColor: "white",
            },
        },
    };

    return (
        <Scatter
            options={options}
            data={data}
            ref={chartRef}
        />
    )
}